export default __webpack_public_path__ + "static/media/defaultInspection.05db3a37.png";